<template>
  <div>
    <v-card class="pa-0 pb-10" tile>
      <v-card-title>
        <h4 class="primary--text">
          {{ $t('spedilink.title') }}
        </h4>
        <v-spacer />
        <v-btn
          v-if="activeTab === 0"
          color="primary"
          class="mr-2"
          depressed
          @click="openAddPersonDialog()"
        >
          {{ $t('spedilink.persons.add') }}
        </v-btn>
        <v-btn
          v-if="activeTab === 1"
          color="primary"
          depressed
          @click="openAddGroupDialog()"
        >
          {{ $t('spedilink.groups.add') }}
        </v-btn>
      </v-card-title>

      <div class="background px-6 my-4">
        <v-tabs
          v-model="activeTab"
          :height="60"
          background-color="background"
          show-arrows
          hide-slider
          center-active
        >
          <v-tab>{{ $t('spedilink.persons.title') }}</v-tab>
          <v-tab>{{ $t('spedilink.groups.title') }}</v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-card class="py-5">
            <SpediLinkPersonsTable ref="personsTable" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="py-5">
            <SpediLinkGroupsTable ref="groupsTable" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <AddSpediLinkPersonDialog
      v-model="addPersonDialog"
      @person-added="onPersonAdded()"
      @close="addPersonDialog = false"
    />

    <AddSpediLinkGroupDialog
      v-model="addGroupDialog"
      @group-added="onGroupAdded()"
      @close="addGroupDialog = false"
    />
  </div>
</template>

<script>
import SpediLinkPersonsTable from '@/views/Spedilink/tables/SpediLinkPersonsTable'
import SpediLinkGroupsTable from '@/views/Spedilink/tables/SpediLinkGroupsTable'
import AddSpediLinkPersonDialog from '@/views/Spedilink/dialogs/AddSpediLinkPersonDialog'
import AddSpediLinkGroupDialog from '@/views/Spedilink/dialogs/AddSpediLinkGroupDialog'

export default {
  name: 'Spedilink',
  components: {
    SpediLinkPersonsTable,
    SpediLinkGroupsTable,
    AddSpediLinkPersonDialog,
    AddSpediLinkGroupDialog
  },
  data () {
    return {
      activeTab: 0,
      addPersonDialog: false,
      addGroupDialog: false
    }
  },
  watch: {
    activeTab (newTab) {
      if (this.$refs.groupsTable) {
        this.$refs.groupsTable.collapseAllRows()
      }
      if (newTab === 0 && this.$refs.personsTable) {
        this.$refs.personsTable.loadPersons()
      } else if (newTab === 1 && this.$refs.groupsTable) {
        this.$refs.groupsTable.loadGroups()
      }
    }
  },
  methods: {
    openAddPersonDialog () {
      this.addPersonDialog = true
    },
    openAddGroupDialog () {
      this.addGroupDialog = true
    },
    async onPersonAdded () {
      this.addPersonDialog = false
      if (this.$refs.personsTable) {
        await this.$refs.personsTable.loadPersons()
      }
    },
    async onGroupAdded () {
      this.addGroupDialog = false
      if (this.$refs.groupsTable) {
        await this.$refs.groupsTable.loadGroups()
      }
    }
  }
}
</script>

<style scoped>
.v-tab::before {
  display: block;
  content: attr(title);
  font-weight: bold;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.v-tab:hover {
  color: var(--v-primary-base) !important;
  text-shadow: 0 0 .7px var(--v-primary-base), 0 0 .7px var(--v-primary-base);
}

.v-tab--active:hover,
.v-tab--active {
  font-weight: bold;
  color: var(--v-primary-base) !important;
  text-shadow: none;
}

.v-tab {
  border-left: solid 1px var(--v-separator-base);
  margin: 10px 0;
}

.v-tab:last-child {
  border-right: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
</style>
